import React, {useEffect, useState} from "react"
import Table from "../component/Table"
import moment from "moment"
import {showLoading, toast} from "../component/Alert"
import API from "../../apiService"
import DatePicker from "react-datepicker";

const MonitoringKehamilan = () => {

    const [datas, setDatas] = useState([])
    const [isLoading, setLoading] = useState(true)
    const [year, setYear] = useState(new Date().getFullYear())
    const years = [
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 1,
        new Date().getFullYear(),
        new Date().getFullYear() + 1,
        new Date().getFullYear() + 2,
    ]

    const getData = async () => {
        showLoading("Mencari Data")
        const res = await API.post("/report/kehamilan", {year})
        if (res.code === 200) {
            toast({ status: "success", text: "Data Ditemukan" })
            setDatas(res.data)
            setLoading(false)
        } else {
            toast({ status: "error", text: "Data tidak ditemukan" })
            setDatas([])
            setLoading(false)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    const getAge = (d) => {
        var b = moment(d)
        var a = new Date()

        a = moment(a)

        var years = a.diff(b, "year")
        b.add(years, "years")

        var months = a.diff(b, "months")
        b.add(months, "months")

        var days = a.diff(b, "days")

        if (years !== 0 && months === 0 && days === 0) {
            return years + " tahun"
        } else if (years === 0 && months === 0) {
            return days + " Hari"
        } else if (years === 0 && days === 0) {
            return months + " Bulan"
        } else if (years === 0) {
            return months + " Bulan " + days + " Hari"
        } else {
            return years + " tahun"
        }
    }

    const getUsiaKehamilan = (hpht) => {
        const a = moment()
        const b = moment(hpht)
        return Math.ceil(a.diff(b, 'days') / 7)
    }

    const getTrimester = (hpht) => {
        const a = moment()
        const b = moment(hpht)
        return Math.ceil(a.diff(b, 'days') / 84)
    }

    const getK = (k) => {

        const Gagal = () => (
            <>
                <label className={'badge badge-danger'}>Gagal</label>
                <button className={'btn btn-sm btn-primary'}>Send</button>
            </>
        )

        return (
            <div style={{width: 90}}>
                <b className={'d-block'}>Scheduled</b>
                {
                    !k.wa ? '-' : <div>{moment(k.wa.due_date).format('DD-MM-YYYY')}</div>
                }
                <hr className={'my-1'}/>
                <b className={'d-block'}>Visit</b>
                {k.visits.length ? k.visits.map(v => (<div>{moment(v.created_at).format('DD-MM-YYYY')}</div>)) : '-'}
                <hr className={'my-1'}/>
                <b className={'d-block'}>Whatsapp</b>
                {
                    !k.wa ? <label className={'badge badge-secondary'}>N / A</label> :
                        moment(k.wa.due_date).isAfter() ? <label className={'badge badge-warning'}>Waiting</label> :
                        k.wa.sent ? <label className={'badge badge-success'}>Terkirim</label> : <Gagal/>
                }
            </div>
        )
    }

    return (
        <div className="container-fluid my-3">
            <div className="row">
                <div className="col">
                    <div className="card">
                        <div className="card-header border-0">
                            <div className="row">
                                <div className="col-md-12">
                                    <h3>Laporan Monitoring Kehamilan</h3>
                                </div>
                            </div>
                        </div>
                        <div className={'card-body'}>
                            <div className="row mb-2">
                                <div className="col-md-4 col-sm-12">
                                    <h3>Tanggal Kunjungan</h3>
                                </div>
                                <select
                                    className="form-control col-md-4 col-sm-12"
                                    value={year}
                                >
                                    {
                                        years.map(v => (<option value={v}>{v}</option>))
                                    }
                                </select>
                                <button
                                    style={{ marginLeft: "2%" }}
                                    className="btn btn-success"
                                    onClick={getData}
                                >
                                    CARI DATA
                                </button>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <div className="card">
                                        <Table
                                            headers={[
                                                "No",
                                                "Nama Suami",
                                                "Umur",
                                                "Nama Istri",
                                                "Alamat",
                                                "Pendidikan",
                                                "Pekerjaan",
                                                "No WA",
                                                "HPHT",
                                                "UK Istri",
                                                "Trimester Ke",
                                                "Status",
                                                "K1",
                                                "K2",
                                                "K3",
                                                "K4",
                                                "K5",
                                                "K6",
                                            ]}
                                            data={datas}
                                            columnMapper={(data, key) => [
                                                data.husband_name,
                                                getAge(data.visit.patients.birth_date),
                                                data.visit.patients.name + ' ' + data.visit.patients.last_name,
                                                data.visit.patients.address,
                                                data.visit.patients.education?.name ?? '',
                                                data.visit.patients.job?.name ?? '',
                                                data.husband_phone,
                                                data.hpht,
                                                getUsiaKehamilan(data.hpht),
                                                getTrimester(data.hpht),
                                                data.status,
                                                getK(data.k1),
                                                getK(data.k2),
                                                getK(data.k3),
                                                getK(data.k4),
                                                getK(data.k5),
                                                getK(data.k6),
                                            ]}
                                            pagination={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MonitoringKehamilan